import { connect } from "react-redux";
import ContadorMinimo from "../../../../components/ContadorMinimo";
import close_icon from "../../../../../assets/icons/close.svg";
import Formulario from "../../../../components/Formulario";
import { mapDispatchToProps, mapStateToProps } from "../../../../../utils/config";
import { useState } from "react";
import Loading from "../../../../components/Loading";
import AlertDialog from "../../../../components/AlertDialog";
import { Main, Container } from "../styled";
import InformacoesGrupoController from "../controller";

function AlterarNomeModal({grupo, setGrupo, errors, setErrors, onClose}){
  const [loading, setLoading] = useState(false);
  const [dadosGrupo, setDadosGrupo] = useState({...grupo});
  const [showSuccess, setShowSuccess] = useState(false);

  const informacoesGrupoController = new InformacoesGrupoController(dadosGrupo, setDadosGrupo, errors, setErrors, setLoading);

  return(
    <Main>
    <Container>
      {loading && <Loading/>}
      {showSuccess && (
        <AlertDialog
          titulo={`Nome alterado com sucesso!`}
          buttonText={"Ver meus dados"}
          buttonOnClick={onClose}
        />
      )}
      <div className="content-modal">
        <section>
          <div className="close" onClick={onClose}>
            <button type="button">
              <img src={close_icon} alt="Icone de fechar"/>
            </button>
          </div>
        </section>

        <section>
          <div className="title">
            <h2>Alterar Nome do Grupo</h2>
          </div>
        </section> 

        <Formulario id="form-alterar-nome">
          
          <div className="form-group">
            <label htmlFor="nome">Nome</label>
            <input type="text" id="nome" name="nome" placeholder="Insira o novo nome do grupo" required autoComplete="off"
              value={dadosGrupo.nome} onChange={(e)=>informacoesGrupoController.validarNome(e)} className={errors.nome && 'input-error'}
            />
            <ContadorMinimo valor={dadosGrupo.nome} minimo={8} campo="O nome" />
          </div>

          <div className="form-group">
          <button type="button" onClick={(e)=>informacoesGrupoController.alterarDados(e, 'form-alterar-nome', setGrupo, setShowSuccess)}>Salvar</button> 
          </div>


              
        </Formulario>
      </div>
    </Container>
    </Main>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AlterarNomeModal);